import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Modal from 'react-modal';
import { useTranslation } from 'react-i18next';
import { useGlobalContext } from '../../hooks/Helper/GlobalContext';

const EXCLUDED_ROUTES = ['/account', '/photo-management'];

export const UploadPhotoModal: React.FC = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { photoBannerVisible } = useGlobalContext();
  const [isOpen, setIsOpen] = useState(false);

  const shouldShow = photoBannerVisible && !EXCLUDED_ROUTES.includes(pathname);

  useEffect(() => {
    if (shouldShow) {
      setIsOpen(true);
    }
  }, [pathname, photoBannerVisible]);

  const handleClose = () => setIsOpen(false);

  const handleUpload = () => {
    setIsOpen(false);
    navigate('/photo-management');
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={handleClose}
      shouldCloseOnOverlayClick={true}
      contentLabel={t('dashboard.profileCard.uploadphoto')}
      overlayClassName="upload-photo-modal-overlay"
      className="upload-photo-modal-content"
    >
      <div className="upload-photo-modal-header">
        <h2 className="upload-photo-modal-title">
          {t('dashboard.profileCard.uploadphoto')}
        </h2>
        <button
          className="upload-photo-modal-close"
          onClick={handleClose}
          aria-label="Close"
        >
          ×
        </button>
      </div>

      <p className="upload-photo-modal-body">
        {t('Banner.CandidateAccessControl.note')}
      </p>

      <div className="upload-photo-modal-footer">
        <button className="cco_btn_upload_photo" onClick={handleUpload}>
          {t('dashboard.profileCard.uploadphoto')}
        </button>
      </div>
    </Modal>
  );
};
